module.exports = __webpack_public_path__ + "img/gmc-logo-white.38946143.svg";